import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const PasswordIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M2.62 18.408v-.923h18.757v.923H2.62Zm.489-5.924-.716-.412.968-1.692H1.428v-.826H3.36l-.968-1.642.716-.412.965 1.642.965-1.642.716.412-.978 1.642H6.72v.826H4.777l.978 1.692-.716.412-.965-1.693-.965 1.693Zm7.923 0-.713-.412.965-1.695H9.351v-.823h1.933l-.965-1.655.713-.412.965 1.655.968-1.655.713.412-.966 1.655h1.934v.823h-1.934l.966 1.695-.713.412-.968-1.693-.965 1.693Zm7.926 0-.716-.412.978-1.695h-1.943v-.823h1.943l-.978-1.655.716-.412.965 1.655.965-1.655.716.412-.969 1.655h1.934v.823h-1.934l.969 1.695-.716.412-.965-1.693-.965 1.693Z"
    />
  </Svg>
)
export default PasswordIcon
